import React from 'react';

import { Dialog } from '@mui/material';
import ModalTransition from '../ModalTransition';

export default(
  ({
    isOpen,
    children,
    paperFullScreenStyles,
    disableContainerPadding,
  }) =>
    <Dialog
      fullScreen
      open={isOpen}
      TransitionComponent={ModalTransition}
      classes={{
        paperFullScreen: paperFullScreenStyles,
      }}
    >
      <div
        style={{
          padding: `${disableContainerPadding ? '0' : '20px'}`,
          marginTop: '20px',
        }}
      >
        {children}
      </div>
    </Dialog>
);
